import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFeatures } from '../contexts/FeaturesContext';
import { interestsAPI } from '../services/api';
import useIsMobile from '../hooks/useIsMobile';
import toast from 'react-hot-toast';

const SERVICES = [
  {
    key: 'marketplace_assistencia24h',
    icon: '🚗',
    emoji: '🆘',
    title: 'Assistência 24h',
    subtitle: 'Guincho, troca de pneu, chaveiro e socorro mecânico',
    price: 'A partir de R$ 3,90/mês',
    tag: 'Mais popular',
    tagColor: '#e97117',
    color: '#14562e',
    bgColor: '#e6f0e9',
    plans: [
      { name: 'Essencial 24h', originalPrice: 'R$ 19,90', price: 'R$ 3,90', period: 'no 1º mês', items: ['Guincho Leve', 'Guincho Utilitário', 'Socorro Mecânico', 'Troca de Pneus'] },
      { name: 'Completa 24h', originalPrice: 'R$ 24,90', price: 'R$ 4,90', period: 'no 1º mês', items: ['Guincho Leve', 'Guincho Utilitário', 'Socorro Mecânico', 'Chaveiro', 'Leva e Traz', 'Motorista Amigo'], recommended: true },
    ],
  },
  {
    key: 'marketplace_seguro',
    icon: '🛡️',
    emoji: '🛡️',
    title: 'Seguro Auto',
    subtitle: 'Cotação e contratação direto pelo NICO',
    price: 'Cotação gratuita',
    color: '#1a5276',
    bgColor: '#e8f0f8',
  },
  {
    key: 'marketplace_abastecer',
    icon: '⛽',
    emoji: '⛽',
    title: 'Abastecer',
    subtitle: 'Cashback em postos parceiros',
    price: 'Até 5% de cashback',
    color: '#7d6608',
    bgColor: '#fef9e7',
  },
  {
    key: 'marketplace_pedagio',
    icon: '🛣️',
    emoji: '🏷️',
    title: 'Pedágio',
    subtitle: 'Tag ativa (Sem Parar) com desconto',
    price: 'Sem mensalidade',
    color: '#5b2c6f',
    bgColor: '#f4ecf7',
  },
  {
    key: 'marketplace_baterias',
    icon: '🔋',
    emoji: '🔋',
    title: 'Baterias',
    subtitle: 'Troca em domicílio em até 50min',
    price: 'A partir de R$ 299',
    color: '#1e8449',
    bgColor: '#e8f8f0',
  },
  {
    key: 'marketplace_emprestimo',
    icon: '💰',
    emoji: '💰',
    title: 'Empréstimo',
    subtitle: 'Use seu veículo como garantia',
    price: 'Até R$ 65 mil',
    tag: 'Crédito pré-aprovado',
    tagColor: '#c94a2f',
    color: '#943126',
    bgColor: '#fdedec',
  },
];

function ServiceCard({ service, onInterest }) {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        background: '#fff', border: '1.5px solid #e5ddc9', borderRadius: '18px',
        padding: '24px', cursor: 'pointer', position: 'relative',
        transition: 'all 0.2s ease', overflow: 'hidden',
        transform: hover ? 'translateY(-2px)' : 'none',
        boxShadow: hover ? '0 8px 24px rgba(15,64,35,.08)' : 'none',
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onInterest(service)}
    >
      {service.tag && (
        <span style={{
          position: 'absolute', top: '14px', right: '14px',
          background: service.tagColor || '#e97117', color: '#fff',
          fontSize: '10px', fontWeight: 700, padding: '3px 10px',
          borderRadius: '999px', textTransform: 'uppercase', letterSpacing: '0.5px',
        }}>
          {service.tag}
        </span>
      )}

      <div style={{
        width: '48px', height: '48px', borderRadius: '14px',
        background: service.bgColor, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        fontSize: '24px', marginBottom: '16px',
      }}>
        {service.emoji}
      </div>

      <h3 style={{
        fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700,
        fontSize: '18px', color: '#14562e', margin: '0 0 6px',
      }}>
        {service.title}
      </h3>

      <p style={{ fontSize: '13px', color: '#6a7268', margin: '0 0 16px', lineHeight: 1.5 }}>
        {service.subtitle}
      </p>

      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        paddingTop: '14px', borderTop: '1px solid #efe8d6',
      }}>
        <span style={{
          fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700,
          fontSize: '14px', color: service.color,
        }}>
          {service.price}
        </span>
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: '4px',
          color: '#14562e', fontSize: '13px', fontWeight: 600,
        }}>
          Ver detalhes
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </span>
      </div>
    </div>
  );
}

function ServiceDetailModal({ service, onClose }) {
  if (!service) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,64,35,.4)',
        backdropFilter: 'blur(6px)', zIndex: 200,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px',
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: '22px', padding: '32px',
        maxWidth: '600px', width: '100%', maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 20px 48px rgba(15,64,35,.14)',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div style={{
              width: '52px', height: '52px', borderRadius: '14px',
              background: service.bgColor, display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: '28px',
            }}>
              {service.emoji}
            </div>
            <div>
              <h2 style={{
                fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800,
                fontSize: '22px', color: '#14562e', margin: 0,
              }}>
                {service.title}
              </h2>
              <p style={{ fontSize: '13px', color: '#6a7268', margin: '2px 0 0' }}>{service.subtitle}</p>
            </div>
          </div>
          <button onClick={onClose} style={{
            width: '36px', height: '36px', borderRadius: '10px', background: '#f4ede0',
            border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#183d24', fontSize: '18px', flexShrink: 0,
          }}>✕</button>
        </div>

        {/* Plans (se tiver) */}
        {service.plans ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '20px' }}>
            {service.plans.map((plan, i) => (
              <div key={i} style={{
                border: plan.recommended ? '2px solid #14562e' : '1.5px solid #e5ddc9',
                borderRadius: '16px', padding: '20px', position: 'relative',
                background: plan.recommended ? '#f9fef6' : '#fff',
              }}>
                {plan.recommended && (
                  <span style={{
                    position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)',
                    background: '#14562e', color: '#fff', fontSize: '10px', fontWeight: 700,
                    padding: '2px 10px', borderRadius: '999px', whiteSpace: 'nowrap',
                  }}>Recomendado</span>
                )}
                <h4 style={{
                  fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700,
                  fontSize: '16px', color: '#14562e', margin: '0 0 10px',
                }}>{plan.name}</h4>
                <div style={{ marginBottom: '14px' }}>
                  <span style={{ fontSize: '13px', color: '#999', textDecoration: 'line-through' }}>{plan.originalPrice}</span>
                  <div>
                    <span style={{
                      fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800,
                      fontSize: '28px', color: '#14562e',
                    }}>{plan.price}</span>
                    <span style={{ fontSize: '12px', color: '#6a7268', marginLeft: '4px' }}>{plan.period}</span>
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {plan.items.map((item, j) => (
                    <span key={j} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#333' }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2f8f52" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            background: service.bgColor, borderRadius: '14px', padding: '24px',
            textAlign: 'center', marginBottom: '20px',
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>{service.emoji}</div>
            <p style={{
              fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700,
              fontSize: '20px', color: service.color, margin: '0 0 6px',
            }}>{service.price}</p>
            <p style={{ fontSize: '13px', color: '#6a7268', margin: 0 }}>
              Em breve disponível no NICO
            </p>
          </div>
        )}

        {/* CTA */}
        <div style={{
          background: '#f4ede0', borderRadius: '14px', padding: '20px',
          textAlign: 'center', marginBottom: '16px',
        }}>
          <p style={{ fontSize: '14px', color: '#6a7268', margin: '0 0 4px' }}>
            🚀 Esse serviço está sendo preparado para você
          </p>
          <p style={{ fontSize: '12px', color: '#999', margin: 0 }}>
            Ao demonstrar interesse, avisaremos quando estiver disponível
          </p>
        </div>

        <button
          onClick={async () => {
            try {
              await interestsAPI.register(service.key);
              toast.success(`Interesse registrado em ${service.title}! Avisaremos quando estiver disponível.`);
            } catch {
              toast.success(`Interesse em ${service.title} registrado!`);
            }
            onClose();
          }}
          style={{
            width: '100%', padding: '14px', borderRadius: '12px', border: 'none',
            background: '#14562e', color: '#fff', fontSize: '15px', fontWeight: 700,
            cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          Tenho interesse — me avise!
        </button>
      </div>
    </div>
  );
}

export default function ServicesPage() {
  const m = useIsMobile();
  const navigate = useNavigate();
  const features = useFeatures?.() || {};
  const [selectedService, setSelectedService] = useState(null);

  // Filtra serviços ativos via feature flags (se flag não existe, mostra por padrão)
  const activeServices = SERVICES.filter(s => {
    const flag = features[s.key];
    return flag === undefined || flag === true;
  });

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <span style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.8px', color: '#e97117', display: 'block', marginBottom: '6px' }}>
          Serviços para seu veículo
        </span>
        <h1 style={{
          fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800,
          textTransform: 'uppercase', fontSize: m ? '26px' : '40px',
          letterSpacing: '-0.02em', margin: '0 0 6px', color: '#14562e', lineHeight: 0.95,
          wordBreak: 'break-word', overflowWrap: 'break-word',
        }}>
          Painel de Serviços
        </h1>
        <p style={{ color: '#6a7268', margin: 0, fontSize: '15px' }}>
          Gerencie toda a vida do seu veículo em um só lugar. Da manutenção à documentação.
        </p>
      </div>

      {/* Grid de serviços */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: m ? '1fr' : 'repeat(3, 1fr)',
        gap: '16px',
      }}>
        {activeServices.map(service => (
          <ServiceCard
            key={service.key}
            service={service}
            onInterest={setSelectedService}
          />
        ))}
      </div>

      {/* Nota de rodapé */}
      <div style={{
        marginTop: '32px', padding: '20px', background: '#fff',
        border: '1px solid #e5ddc9', borderRadius: '14px',
        display: 'flex', alignItems: 'center', gap: '12px',
      }}>
        <span style={{ fontSize: '20px' }}>🔧</span>
        <p style={{ fontSize: '13px', color: '#6a7268', margin: 0, lineHeight: 1.5 }}>
          Todo serviço contratado pelo NICO entra automaticamente no histórico do veículo, com validação profissional inclusa.
        </p>
      </div>

      {/* Modal de detalhes */}
      <ServiceDetailModal
        service={selectedService}
        onClose={() => setSelectedService(null)}
      />
    </div>
  );
}
